<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="lead_name"
                                       label="Lead name"
                                       size="6"
                                       :isFocus="true"
                                       v-model:field="search.lead_name" />

                        <FormInputText fieldName="recommended_by"
                                       label="Recommended by"
                                       size="6"
                                       v-model:field="search.recommended_by" />

                        <FormMultiselect fieldName="dctcategory_id"
                                         label="Category"
                                         size="6"
                                         :options="select?.dct_lead_categories"
                                         v-model:field="search.dctcategory_id" />

                        <FormMultiselect fieldName="dctsource_id"
                                         label="Lead source"
                                         size="6"
                                         :options="select?.dct_lead_sources"
                                         v-model:field="search.dctsource_id" />
                        <FormMultiselect fieldName="service_id"
                                         label="Service"
                                         size="6"
                                         :options="select?.services"
                                         v-model:field="search.service_id" />

                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["dct_lead_categories", "dct_lead_sources", "services"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
